import { createApp, computed } from "vue";
import ShiftCalendar from '../vue/ShiftCalendar.vue';
import ShiftViewToggleButton from '../vue/ShiftViewToggleButton.vue'
import { reactiveSlotLogMap } from "./slotLog";
import { i18n } from '../i18n';

export function mountShiftCalendarComponent(mountPoint, calendarReactiveObject, slotMap, props, roleDates, sectionMap, useShiftBorders) {
  const app = createApp(ShiftCalendar, props);
  app.config.unwrapInjectedRef = true;
  app.provide('calendarReactiveObject', computed(() => calendarReactiveObject));
  app.provide('roleDates', roleDates);
  app.provide('slotMap', slotMap);
  app.provide('sectionMap', sectionMap);
  app.provide('slotLogMap', computed(() => reactiveSlotLogMap));
  app.provide('useShiftBorders', useShiftBorders);
  app.use(i18n);
  window[mountPoint] = app.mount(mountPoint);
}

export function mountShiftViewToggleButtonComponent(mountPoint, calendarReactiveObject) {
  const app = createApp(ShiftViewToggleButton, {});
  app.config.unwrapInjectedRef = true;
  app.provide('calendarReactiveObject', computed(() => calendarReactiveObject));
  app.use(i18n);
  window[mountPoint] = app.mount(mountPoint);
}

export function addRequestSlotsToSlotMap(slotMap = {}) {
  const slotIds = Object.keys(slotMap);
  try {
    slotIds.forEach(slotId => {
      const requestedSlot = slotMap[slotId]?.RequestedSlot;
      if (!requestedSlot) {
        return
      }
      slotMap[requestedSlot.ID] = requestedSlot
    })
  } catch (err) {
    throw err
  }
}
